<template>
  <div>
    <tr v-for="[key, value] of Object.entries(compositions)" :key="key">
      <td>{{ key }}:</td>
      <td>
        <Composition :composition="value"></Composition>
      </td>
    </tr>
    <!-- {{ compositions }} -->
  </div>
</template>

<script>
import Composition from "./Composition.vue";
export default {
  name: "Compositions",
  components: {
    Composition,
  },
  props: {
    compositions: Object,
  },
  data: () => ({}),
  methods: {},
};
</script>
